
    import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
    import {
        faChevronDown as farChevronDown,
    } from '@fortawesome/pro-regular-svg-icons/faChevronDown';

    import {
        faChevronRight as farChevronRight,
    } from '@fortawesome/pro-regular-svg-icons/faChevronRight';

    export default {
        name: 'Accordion',

        components: {
            FontAwesomeIcon,
        },

        props: {
            name: {
                type: String,
                default: '',
            },
            title: {
                type: String,
                default: '',
            },
        },

        data() {
            return {
                isOpen: false,
                icons: {
                    farChevronDown,
                    farChevronRight,
                },
            };
        },

        methods: {
            toggle() {
                this.isOpen = !this.isOpen;
                if (this.isOpen) {
                    this.open();
                } else {
                    this.close();
                }
            },

            close() {
                this.$velocity(
                    this.$refs.collapse,
                    'slideUp',
                    {
                        easing: 'easeInOut',
                        duration: 300,
                    },
                );
            },

            open() {
                this.$velocity(
                    this.$refs.collapse,
                    'slideDown',
                    {
                        easing: 'easeInOut',
                        duration: 300,
                    },
                );
            },
        },
    };
